import React from 'react';
import ClaycoForm from '../../components/form_elements/clayco-form';
import FormInput from '../../components/form_elements/form-input';
import { RequiredNumber, RequiredString } from '../../components/form_elements/form-validators';
import SubmitButton from '../../components/form_elements/submit-button';
import * as Yup from 'yup';
import useMsalApi from "../../components/use-msal-api";
import { useDispatch } from 'react-redux';
import { updateEnrollments } from '../../redux/actions/enrollments-actions';
import { useState } from 'react';
import { useNavigate } from 'react-router';


const EmployeeLookup = () => {
    const [callApi] = useMsalApi();
    const dispatch = useDispatch();
    const [processing, setProcesing] = useState(false);
    const navigate = useNavigate();

    const validationSchema = Yup.object().shape({
        employeeNumber: RequiredNumber("Required")
    });

    const onSubmit = async(formData) => {
        setProcesing(false);

        const frm = validationSchema.cast(formData);

        const results = await callApi(`Enrollments/enroll/${frm.employeeNumber}`, "GET");
        if(!results.error){
            dispatch(updateEnrollments(results));
            navigate("/");

          }
          setProcesing(false);
      }

    return ( 
        <ClaycoForm schema={validationSchema} onSubmit={onSubmit}>
            <div className='flex items-center'>
                <FormInput name="employeeNumber" label="Employee Number" />
                <div>
                    <SubmitButton submitting={processing} props={{size:"md"}}>Enroll</SubmitButton>
                </div>
            </div>
        </ClaycoForm>
     );
}
 
export default EmployeeLookup;